<template>
  <div class="duplicateremovalsuccessDialog">
    <el-dialog :visible.sync="duplicateremovalsuccessVisible" center :show-close="true"
               custom-class="duplicateremovalsuccess" :before-close="handleClose">
      <template slot="title">
        <DialogsHeader :title="$t('memoryBankV2.duplicateremoval')" />
      </template>
      <div class="duplicateremovalsuccess-content">
        <div class="success-img">
          {{$t('memoryBankV2.Processingsucceeded')}}
        </div>
        <p> <i>{{second}}</i> {{$t('memoryBankV2.Willautomaticallycloseinseconds')}}</p>
      </div>
      <template slot="footer">
        <el-button size="small" @click="handleClose">{{$t('project.close')}}</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
//标题组件
import DialogsHeader from '@/common/dialogsHeader';
export default {
  name: "duplicateremovalsuccessDialog",
  data() {
    return {
      second: 5
    }
  },
  components: { DialogsHeader },
  props: {
    duplicateremovalsuccessVisible: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    duplicateremovalsuccessVisible: {
      handler(value) {
        if (value) {
          this.second = 5;
          let timer = window.setInterval(() => {
            this.second--;
            if (this.second === 0) {
              clearInterval(timer);
              timer = null;
              this.$emit('handleClose')
            }
          }, 1000)
        }
      }
    }
  },

  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
  },
}
</script>
<style lang="less" scoped>
.duplicateremovalsuccessDialog {
  /deep/.duplicateremovalsuccess {
    width: 359px;
    background: #ffffff;
    box-shadow: 0px 10px 28px 1px rgba(51, 51, 51, 0.18);
    border-radius: 4px 4px 4px 4px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0px !important;
    .el-dialog__body {
      padding: 0px;
    }
    .duplicateremovalsuccess-content {
      .success-img {
        width: 100%;
        height: 120px;
        background: url("../images/mergeSuccess.png") no-repeat center center;
        text-align: center;
        line-height: 230px;
        font-size: 14px;
        font-weight: bold;
        color: #303133;
      }
      p {
        width: 100%;
        text-align: center;
        margin-top: 16px;
        i {
          color: #0078fc;
        }
      }
    }
    .el-dialog__footer {
      padding: 20px 0px 32px 0px;
    }
  }
}
</style>